<template>
  <v-dialog v-model="dialogIsOpen" max-width="400px">
    <v-card class="d-flex flex-column pt-16 px-16 rounded-lg" min-height="50vh">
      <v-card-text class="my-auto d-flex flex-column align-center">
        <p class="text-center font-weight-medium text-subtitle-1">
          <slot></slot>
        </p>
      </v-card-text>

      <v-card-actions class="d-flex flex-column align-stretch">
        <app-button invert gradient :label="$t('button.okay')" class="py-5 mb-12" @click="dialogIsOpen = false" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean
    }
  },
  computed: {
    dialogIsOpen: {
      get() {
        return this.value
      },
      set(isOpen) {
        this.$emit('input', isOpen)
        this.$emit('close')
      }
    }
  }
}
</script>
